import * as React from 'react';
import OrderList from '../components/OrderList/OrderListContainer.js';

const Orders = ()=>/*#__PURE__*/ React.createElement("div", {
        className: "myaccount-orders"
    }, /*#__PURE__*/ React.createElement(OrderList, null))
;
var Orders$1 = Orders;

export { Orders$1 as default };
//# sourceMappingURL=Orders.js.map
